import { Visitable } from './Visitable';
import { Visitor } from './Visitor';
import { Booking, BookingConstraints } from './Booking';
import PageInfo from './PageInfo';
import {isNullOrUndefined} from "../utils";


export interface BookingsProps {
    bookings: Array<Booking>;
    pageInfo: PageInfo;
}

export class Bookings implements Visitable {

    private _bookings: Array<Booking>;
    private _pageInfo: PageInfo;
    private _links: any;

    constructor(bookingData: any) {
        let bookObject;
        this._bookings = new Array<Booking>();
        bookingData?._embedded.bookings.forEach((booking: any) => {
                bookObject =
                    new Booking(booking.id, booking.userId, booking.testDate, booking.created,
                                booking.server, booking._links);

                if (!isNullOrUndefined(booking.constraints)) {

                    let bc: BookingConstraints =
                        new BookingConstraints(booking.constraints.dnsSecAlg, booking.constraints.domain);
                    bookObject.constraints = bc;
                }

                this._bookings.push(bookObject);
            });
        this._pageInfo = bookingData.page;
    }

    accept(visitor: Visitor): void {
        visitor.visitBookings(this);
    }

    get bookings(): Booking[] {
        return this._bookings;
    }

    set bookings(value: Booking[]) {
        this._bookings = value;
    }

    get pageInfo(): PageInfo {
        return this._pageInfo;
    }

    get links(): any {
        return this._links;
    }
}